// Postcode → { hall key, primary suburb, region } for the Sunshine Coast.
// Maps to one of: mudjimba, kawana, eudlo
export const POSTCODES = {
  // North Sunshine Coast → Mudjimba hall
  "4564": { hall: "mudjimba", region: "North Sunshine Coast", suburbs: ["Mudjimba", "Twin Waters", "Pacific Paradise"] },
  "4558": { hall: "mudjimba", region: "North Sunshine Coast", suburbs: ["Maroochydore", "Kuluin"] },
  "4560": { hall: "mudjimba", region: "North Sunshine Coast", suburbs: ["Bli Bli", "Diddillibah", "Rosemount", "Nambour"] },
  "4573": { hall: "mudjimba", region: "North Sunshine Coast", suburbs: ["Coolum Beach", "Yaroomba", "Marcoola"] },
  "4574": { hall: "mudjimba", region: "North Sunshine Coast", suburbs: ["Coolum Beach"] },
  "4561": { hall: "mudjimba", region: "North Sunshine Coast", suburbs: ["Eumundi"] },

  // Central → Kawana hall
  "4575": { hall: "kawana", region: "Central Sunshine Coast", suburbs: ["Buddina", "Bokarina", "Currimundi", "Warana", "Wurtulla", "Parrearra", "Kawana Island", "Minyama", "Birtinya"] },
  "4557": { hall: "kawana", region: "Central Sunshine Coast", suburbs: ["Mooloolaba", "Mountain Creek", "Alexandra Headland", "Meridan Plains"] },
  "4556": { hall: "kawana", region: "Central Sunshine Coast", suburbs: ["Buderim", "Mons", "Forest Glen", "Tanawha", "Sippy Downs", "Palmview"] },
  "4551": { hall: "kawana", region: "Central Sunshine Coast", suburbs: ["Caloundra"] },
  "4553": { hall: "kawana", region: "Central Sunshine Coast", suburbs: ["Glenview", "Little Mountain"] },

  // Hinterland → Eudlo hall
  "4554": { hall: "eudlo", region: "West & Hinterland", suburbs: ["Eudlo", "Mooloolah Valley", "Diamond Valley", "Ilkley", "Landers Shoot", "Hunchy", "West Woombye", "Chevallum"] },
  "4555": { hall: "eudlo", region: "West & Hinterland", suburbs: ["Palmwoods"] },
  "4559": { hall: "eudlo", region: "West & Hinterland", suburbs: ["Woombye"] },
  "4560-w": { hall: "eudlo", region: "West & Hinterland", suburbs: ["Kureelpa", "Balmoral Ridge"] },
  "4560-x": { hall: "eudlo", region: "West & Hinterland", suburbs: ["Hunchy"] },
};

export function lookupPostcode(code) {
  const clean = (code || "").toString().trim().slice(0, 4);
  return POSTCODES[clean] || null;
}
